import { jsx, jsxs } from "react/jsx-runtime";
import { QuizRenderer } from "../components/quiz-types/quiz-renderer.js";
import { DebugQuizId } from "../components/quiz-types/shared/debug-quiz-id.js";
import { QuizNumberColorProvider, OptionImageScaleProvider, AdditionalImageScalesProvider, ImageScaleMultiplierProvider } from "../components/quiz-types/print/print-common.js";
import "../components/quiz-types/shared/quiz-blank.js";
import "react";
import "../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
/* empty css                                                                       */
import "react-i18next";
import "../components/quiz-types/shared/quiz-style-context.js";
import "../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../utils/quiz-parser.js";
import { PrintQuizDescription } from "../components/quiz-types/print/print-quiz-description.js";
import { toQuizData, LAYOUT } from "./constants.js";
const STEP_NUMBER_COLORS = {
  0: "#FF9F19",
  // Step 1 — Orange
  1: "#0066CC",
  // Step 2 — Blue
  2: "#00BFA0"
  // Step 3 — Teal
};
function PrintQuizItem({ script, number, stepIdx = 0, compact, imageScale, additionalImageScales, optionImageScale, spacingOverride, highlighted, onSelect, showCorrectAnswers, correctAnswers, showDescription }) {
  const quizData = toQuizData(script);
  const quizId = String(script.quizId ?? "");
  const isStep2 = stepIdx === 1;
  const numberColor = STEP_NUMBER_COLORS[stepIdx];
  const defaultSpacing = isStep2 ? 24 : LAYOUT.questionSpacing;
  const finalSpacing = spacingOverride ?? defaultSpacing;
  const content = /* @__PURE__ */ jsx(
    QuizRenderer,
    {
      quizType: quizData.type,
      quizId,
      quiz: quizData,
      mode: "print",
      number,
      hideSubmitButton: true,
      disableSound: true,
      compact,
      showCorrectAnswers,
      correctAnswers
    },
    quizId
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `break-inside-avoid${highlighted ? " outline outline-2 outline-offset-2 outline-blue-500 rounded print:outline-none" : ""}`,
      style: {
        paddingBottom: `${finalSpacing}px`,
        pageBreakInside: "avoid",
        position: "relative"
      },
      onClick: onSelect,
      children: [
        /* @__PURE__ */ jsx("div", { className: "print:hidden", style: { position: "absolute", top: 0, right: 0, zIndex: 10 }, children: /* @__PURE__ */ jsx(DebugQuizId, { quizId }) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "print-quiz-wrapper",
            style: { display: "flex", justifyContent: "center" },
            children: /* @__PURE__ */ jsx("div", { style: {
              width: "100%",
              maxWidth: 650,
              ...isStep2 && {
                border: "2px solid #E6E6E6",
                borderRadius: "16px",
                padding: "20px 16px 32px 16px"
              }
            }, children: /* @__PURE__ */ jsx(QuizNumberColorProvider, { value: numberColor, children: /* @__PURE__ */ jsx(OptionImageScaleProvider, { value: optionImageScale ?? 1, children: /* @__PURE__ */ jsxs(AdditionalImageScalesProvider, { value: additionalImageScales ?? 1, children: [
              imageScale != null && imageScale !== 1 ? /* @__PURE__ */ jsx(ImageScaleMultiplierProvider, { value: imageScale, children: content }) : content,
              showDescription && /* @__PURE__ */ jsx(
                PrintQuizDescription,
                {
                  description: script.description,
                  commentaryImages: script.commentaryImages,
                  vars: script.vars,
                  compact
                }
              )
            ] }) }) }) })
          }
        )
      ]
    }
  );
}
export {
  PrintQuizItem
};
//# sourceMappingURL=PrintQuizItem.js.map
